import { SportId } from '@libs/sports-api-consts';
import { StatsLvl } from './StatsLvl';

export const enum AreaType {
    Country = 'country',
    International = 'international'
}

export const enum CompetitionType {
    CountryLeague = 'country_league',
    CountryCups = 'country_cups',
    International = 'international',
    InternationalClubs = 'international_clubs',
    Friendly = 'friendly',
    Individual = 'individual',
    Team = 'team',
    Single = 'single',
    Double = 'double',
    Mixed = 'mixed',
    Undefined = 'undefined'
}

export const enum Gender {
    Male = 'male',
    Female = 'female',
    Mixed = 'mixed'
}

export interface Competition {
    id: number
    short_name: string
    mini_name: string
    slug: string
    gender: Gender
    type: CompetitionType
    stats_lvl: StatsLvl
    sport_id: SportId
    sport_name: string
    area_id: number
    area_code: string
    area_name: string
    area_type: AreaType
    tour_id: '' | number
    tour_name: '' | number
    area_sort: number
}

export interface CompetitionName {
    id: number
    short_name: string
    mini_name: string
}
